import { BestChoiceType } from "./types";

export const bestChoiceContents: BestChoiceType[] = [
  {
    id: 0,
    title: "کیفیت تضمین‌شده",
    description: "محصولات ما استانداردهای جهانی را پاس می‌کنند.",
    url: "/assets/images/aboutUsPage/bestChoice/bestChoice1.jpg",
  },
  {
    id: 1,
    title: "قیمت رقابتی",
    description: "بدون واسطه و با بهترین قیمت در بازار.",
    url: "/assets/images/aboutUsPage/bestChoice/bestChoice2.jpg",
  },
  {
    id: 2,
    title: "پشتیبانی ۲۴/۷",
    description: "همیشه کنار شما هستیم، حتی بعد از خرید.",
    url: "/assets/images/aboutUsPage/bestChoice/bestChoice3.jpg",
  },
  {
    id: 3,
    title: "تجربه و تخصص",
    description: "سال‌ها حضور موفق در صنعت انرژی خورشیدی.",
    url: "/assets/images/aboutUsPage/bestChoice/bestChoice4.jpg",
  },
  {
    id: 4,
    title: "نوآوری مستمر",
    description: "به‌روزترین تکنولوژی‌ها را در اختیار شما قرار می‌دهیم.",
    url: "/assets/images/aboutUsPage/bestChoice/bestChoice5.jpg",
  },
  {
    id: 5,
    title: "سرویس سریع و مطمئن",
    description: "تحویل به موقع و خدمات بی‌وقفه.",
    url: "/assets/images/aboutUsPage/bestChoice/bestChoice6.jpg",
  },
  {
    id: 6,
    title: "رضایت مشتریان",
    description: "اعتماد هزاران مشتری راضی، افتخار ماست.",
    url: "/assets/images/aboutUsPage/bestChoice/bestChoice7.jpg",
  },
];
